import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { FormText, WhatsLine } from "~/features/doctorForm/FormLayout";
import { logoSrc } from "~/shared/ui/brand/Logo";
import BannerModal from "../BannerModal";

// Textos legais mantidos literalmente de FooterDesktopStep1/HeaderDesktopStep1 (F1: sem ilustrações; F2: rodapé único).
const RATES = [
  ["09,90%", "para antecipações de plantões que você tem a receber nos próximos 30 dias;"],
  ["16,50%", "para antecipações de plantões que você tem a receber entre 31 e 60 dias;"],
  ["19,90%", "para antecipações de plantões que você tem a receber entre 61 e 90 dias."],
];

const Step1 = ({ setDisabledNext, mobile }) => {
  const [bannerModalOpen, setBannerModalOpen] = useState(false);
  useEffect(() => {
    setDisabledNext(false);
  }, [setDisabledNext]);

  return (
    <Box>
      <BannerModal open={bannerModalOpen} setOpen={setBannerModalOpen} isMobile={mobile} />
      <Typography component="h1" sx={{ fontSize: mobile ? 20 : 26, fontWeight: 700, color: "primary.main", lineHeight: 1.3 }}>
        SOLICITAÇÃO DE ANTECIPAÇÃO DE PAGAMENTOS DE PLANTÕES NA ANTECIPE INVESTIMENTOS E PARTICIPAÇÕES S/A
      </Typography>
      <FormText sx={{ mt: 2, color: "text.secondary" }}>
        A <b style={{ color: "#17384c" }}>ANTECIPE</b> promove independência financeira a você, médico(a), disponibilizando pagamento antecipado aos plantões que
        tenha realizado com as empresas parceiras da ANTECIPE.
      </FormText>
      <Box sx={{ mt: 3, display: "flex", gap: 1.5, alignItems: "center", p: 2, borderRadius: 2, bgcolor: "#e0f7fc" }}>
        <Box sx={{ width: 40, height: 40, borderRadius: "50%", bgcolor: "#fff", display: "grid", placeItems: "center", flexShrink: 0 }}>
          <ScheduleIcon sx={{ color: "#0592b5" }} aria-hidden />
        </Box>
        <FormText>
          As solicitações realizadas serão pagas em até <b>24h</b> úteis após a contratação.
        </FormText>
      </Box>
      <FormText sx={{ mt: 3 }}>
        Com custos menores que os juros do cheque especial e da maioria dos empréstimos disponíveis do mercado, a ANTECIPE é uma ferramenta para seu melhor
        planejamento financeiro.
      </FormText>
      <Paper variant="outlined" sx={{ mt: 3, borderRadius: 3, overflow: "hidden", borderColor: "#cfe9f2" }}>
        <Box sx={{ px: mobile ? 2 : 3, py: 2, bgcolor: "primary.main", color: "#fff", display: "flex", alignItems: "center", gap: 1.5 }}>
          <img src={logoSrc("symbol", "negative")} alt="" aria-hidden style={{ width: 32, height: 32, flexShrink: 0 }} />
          <Typography sx={{ fontWeight: 600, fontSize: mobile ? 16 : 18 }}>O custo total sob o valor da antecipação é de:</Typography>
        </Box>
        <Box sx={{ px: mobile ? 2 : 3, py: 1 }}>
          {RATES.map(([rate, text]) => (
            <Box key={rate} sx={{ display: "flex", gap: 2, alignItems: "baseline", py: 1.5, borderBottom: "1px solid #eceef1" }}>
              <Typography sx={{ fontSize: mobile ? 20 : 24, fontWeight: 700, color: "primary.main", minWidth: mobile ? 84 : 104 }}>{rate}</Typography>
              <FormText>{text}</FormText>
            </Box>
          ))}
          <FormText sx={{ py: 2, color: "text.secondary", fontSize: 14 }}>
            Nesta fase, trata-se somente do pedido para você avaliar, aceitar e validar a contratação.
          </FormText>
        </Box>
      </Paper>
      <WhatsLine />
    </Box>
  );
};

export default Step1;
